import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import { getProductPath } from '@finect/front-resources/Products';
import { productTypes, securityTypes } from '../commons/productTypes';
import { SecurityCard } from './SecurityCard';
import { CompanyCard } from './CompanyCard';
import { DefaultProductCard } from './DefaultProductCard';
export var ProductCard = function ProductCard(_ref) {
  var entity = _ref.entity,
    withLink = _ref.withLink,
    withCompany = _ref.withCompany;
  var id = entity.id,
    subtype = entity.subtype,
    name = entity.name,
    web = entity.web,
    link = entity.link,
    image = entity.image,
    chartData = entity.chartData,
    currency = entity.currency,
    lastQuote = entity.lastQuote,
    fund = entity.fund,
    managementCompany = entity.managementCompany,
    company = entity.company;
  if (subtype && securityTypes.includes(subtype)) {
    var unit = currency && currency.code || '';
    var path = getProductPath({
      entity: entity,
      subtype: subtype
    });
    var product = {
      name: name,
      link: path,
      chart: chartData && chartData.data || [],
      category: productTypes[subtype] || subtype,
      price: {
        unit: unit,
        value: lastQuote && lastQuote.price || null
      },
      company: withCompany ? fund && fund.managementCompany.name || managementCompany && managementCompany.name || company && company.name || '' : null,
      variation: {
        unit: unit,
        value: chartData && chartData.chage || lastQuote && lastQuote.chage || 0,
        percentage: chartData && chartData.percentChange || lastQuote && lastQuote.percentChange || 0
      }
    };
    return React.createElement(SecurityCard, {
      name: product.name,
      category: product.category,
      company: product.company,
      link: product.link,
      price: product.price,
      variation: product.variation,
      chart: product.chart,
      withLink: path.includes('undefined') ? false : withLink
    });
  }
  if (subtype && subtype === 'service') {
    return React.createElement(CompanyCard, {
      id: id,
      type: subtype && productTypes[subtype] || '',
      name: name,
      image: image,
      link: link,
      web: web,
      withLink: withLink
    });
  }
  if (!subtype || !securityTypes.includes(subtype)) {
    var _path = getProductPath({
      entity: entity,
      subtype: subtype
    });
    return React.createElement(DefaultProductCard, {
      id: id,
      type: subtype && productTypes[subtype] || '',
      name: name,
      image: image,
      path: _path.includes('undefined', '#') ? null : _path,
      link: link,
      web: web,
      withLink: withLink
    });
  }
};